import { Zap, KeyRound, Cog, Clock, ArrowRight } from "lucide-react";
import { SERVICES, PHONE_TEL } from "@/lib/site";
import Reveal, { SectionHead } from "@/components/Reveal";

const ICONS = { zap: Zap, key: KeyRound, cog: Cog };

export default function Services() {
  return (
    <section id="servizi" className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHead
          kicker="Cosa risolviamo"
          title="Servizi di emergenza, 24 ore su 24"
          sub="Tre specializzazioni, un solo numero. Ogni intervento parte con una diagnosi chiara e un prezzo detto in anticipo."
        />

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {SERVICES.map((service, i) => {
            const Icon = ICONS[service.icon];
            return (
              <Reveal key={service.id} delay={0.08 * i} className="h-full">
                <article
                  data-testid={`service-card-${service.id}`}
                  className="group flex h-full flex-col overflow-hidden rounded-3xl border border-line bg-card transition-all duration-500 hover:-translate-y-2 hover:border-volt/40 hover:shadow-[0_24px_60px_rgba(0,0,0,0.5)]"
                >
                  <div className="relative h-48 overflow-hidden sm:h-52">
                    <img
                      src={service.img}
                      alt={service.alt}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div
                      aria-hidden="true"
                      className="absolute inset-0 bg-gradient-to-t from-card via-card/30 to-transparent"
                    />
                    <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-night/80 px-3 py-1.5 font-mono text-[11px] font-medium uppercase tracking-[0.14em] text-volt backdrop-blur-sm">
                      <Clock size={12} strokeWidth={2.5} />
                      {service.eta}
                    </span>
                  </div>

                  <div className="flex flex-1 flex-col p-6 sm:p-7">
                    <div className="flex items-center gap-3">
                      <span className="flex h-10 w-10 items-center justify-center rounded-xl border border-volt/30 bg-volt/10">
                        <Icon size={19} className="text-volt" strokeWidth={2.2} />
                      </span>
                      <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">
                        {service.tag}
                      </span>
                    </div>

                    <h3 className="mt-4 font-display text-xl font-bold text-white sm:text-2xl">
                      {service.name}
                    </h3>

                    <ul className="mt-5 flex-1 space-y-3">
                      {service.bullets.map((bullet) => (
                        <li key={bullet} className="flex items-start gap-2.5 text-sm text-slate-300">
                          <ArrowRight size={15} className="mt-0.5 shrink-0 text-volt" strokeWidth={2.4} />
                          {bullet}
                        </li>
                      ))}
                    </ul>

                    <a
                      href={PHONE_TEL}
                      data-testid={`service-card-${service.id}-call`}
                      className="mt-7 flex h-12 items-center justify-center gap-2 rounded-full border border-volt/40 bg-volt/5 font-display text-sm font-bold text-volt transition-all duration-300 hover:bg-volt hover:text-night"
                    >
                      Chiama ora
                      <ArrowRight size={16} strokeWidth={2.4} />
                    </a>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
